import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../login/connect/Login';
import moment from 'jalali-moment';
import Loader from '../../components/Loader/Loader';
import { useBuyFileSubs } from '../../components/PelakApis/useBuyFileSub';
import withAuth from '../../hoc/withAuth';

const MySubscription = () => {
    const navigate = useNavigate();
    const { getUserInfoByToken } = useAuth((state) => state.actions);
    const { setSelectedSubscription, clearSelectedSubscription } = useBuyFileSubs((state) => state.actions);

    useEffect(() => {
        getUserInfoByToken(0);
        clearSelectedSubscription();
    }, []);

    const loader = useAuth((state) => state.loader);
    const subscriptionMains = useAuth((state) => state.subscriptionMains);

    const CalculateRemainingDays = (endDate) => {
        if (!endDate) return "بدون تاریخ";
        const endDateObj = new Date(endDate);
        const currentDate = new Date();
        const timeDifference = endDateObj - currentDate;
        const remainingDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        if (remainingDays > 0) { return ` ${remainingDays} روز` }
        else if( remainingDays > 0){
            { return `  اشتراک شما منقضی شده است` }
        }
        // if (false) { return ` ${remainingDays} روز` }
        // else if (true) {
        //     { return `  اشتراک شما منقضی شده است` }
        // }

    };

    const notExpiredSubscriptions = subscriptionMains.filter(
        (subscription) => new Date(subscription?.endDate) >= new Date()
    );
    const subscription = notExpiredSubscriptions[0]
    return (
        <>
            {/* Mobile View */}
            <div className='hidden lg:block MySubscition-mobile'>
                <div className="w-full items-center justify-center py-2 z-40 sm:relative md:relative h-9 bg-white border-b top-0 sm:flex md:flex md:items-center fixed">
                    <h1 className='w-full text-center font-bold'>اشتراک‌های من</h1>
                    <Link className='absolute flex items-center right-4 top-2' onClick={() => navigate(-1)}>
                        <img src='/icons/arrow-right.svg' alt='icon-right' />
                    </Link>
                </div>


                {/* Subscription List */}
                <div className='bg-white mx-3'>
                    {loader ? (
                        <Loader />
                    ) :
                        // notExpiredSubscriptions?.length > 0 ? (
                        // notExpiredSubscriptions.map((subscription) => (

                        subscription ?
                            (<div key={subscription.id} className=' border-[#000000] dark:border-slate-50 mx-2 my-4 w-full px-6 py-2'>
                                <p className='text-base font-medium mb-3 text-black dark:text-slate-200 text-center'>
                                    {typeof subscription.description === 'string' && subscription.description}
                                </p>
                                <p className='text-[#454545] dark:text-slate-200'>
                                    {subscription.tblUsrSubscriptionDetails
                                        .map((district) => district.bseCityState?.locName)
                                        .join('/')}
                                </p>
                                <div className='w-[80%] h-[1px] bg-[#B9B9B9] my-5 mx-auto'></div>
                                <div className='flex items-center justify-between'>
                                    <p className='text-[#454545] dark:text-slate-400'>تاریخ خرید اشتراک :</p>
                                    <p className='text-[#454545] dark:text-slate-400'>
                                        {moment(subscription.startDate, 'YYYY-MM-DDTHH:mm:ss.SS').locale('fa').format('jYYYY/jMM/jDD')}
                                    </p>
                                </div>
                                <div className='w-[80%] h-[1px] bg-[#B9B9B9] my-5 mx-auto'></div>
                                <div className='flex items-center justify-between mb-2'>
                                    <p className='text-[#454545] flex items-baseline dark:text-[14px] dark:text-slate-400'>
                                        اعتبار باقی مانده : &nbsp;
                                        <span className='dark:text-orange-400'>
                                            {CalculateRemainingDays(subscription.endDate)}
                                        </span>
                                    </p>

                                </div>
                                <div className='w-[80%] h-[1px] bg-[#B9B9B9] my-5 mx-auto'></div>
                            </div>)
                            // ))

                            : (<p className='text-center py-10'>هیچ اشتراک فعالی موجود نیست</p>)



                    }
                </div>
                <div className=' w-full  '>
                    <div
                        className='flex items-center cursor-pointer w-[174px] border border-[1px]-white rounded-lg mx-auto justify-center py-1 px-3'
                        onClick={() => {
                            setSelectedSubscription(subscription);
                            navigate('/BuyFilingSubscription?renewal=true');
                        }}
                    >
                        <p className='!text-[#A6E8A5]'> خرید  و  افزایش اعتبار</p>
                        <img src='/icons/pelak-arrow-back-simple.svg' alt='arrow icon' />
                    </div>
                </div>
            </div>

            {/* Desktop View */}
            <div className='block lg:hidden p-4 MySubscition-desktop text-[#454545] dark:text-slate-200 bg-white dark:bg-gray-800'>


                {/* Subscription Table */}
                <table className='border border-[#B9B9B9] dark:border-slate-500 w-full rounded-xl'>
                    <thead className='bg-gray-100 dark:bg-gray-600 text-[#04327A] dark:text-slate-200 leading-9'>
                        <tr>
                            <th className='border border-[#B9B9B9] dark:border-slate-500'>نوع اشتراک</th>
                            <th className='border border-[#B9B9B9] dark:border-slate-500'>محله‌ها</th>
                            <th className='border border-[#B9B9B9] dark:border-slate-500'>تاریخ خرید اشتراک</th>
                            <th className='border border-[#B9B9B9] dark:border-slate-500'>اعتبار باقی مانده</th>

                        </tr>
                    </thead>
                    <tbody>
                        {
                            // notExpiredSubscriptions?.length > 0 ? (
                            subscription ?
                                (
                                    <tr >
                                        <td className='border border-[#B9B9B9] dark:border-slate-500 leading-9'>
                                            {subscription.description}
                                        </td>
                                        <td className='border border-[#B9B9B9] dark:border-slate-500 leading-9 text-center'>
                                            {subscription.tblUsrSubscriptionDetails.map((d) => d.bseCityState?.locName).join('/')}
                                        </td>
                                        <td className='border border-[#B9B9B9] dark:border-slate-500 leading-9 text-center'>
                                            {moment(subscription.startDate, 'YYYY-MM-DDTHH:mm:ss.SS').locale('fa').format('jYYYY/jMM/jDD')}
                                        </td>
                                        <td className='border border-[#B9B9B9] dark:border-slate-500 leading-9 text-center'>
                                            <div>{CalculateRemainingDays(subscription.endDate)} </div>
                                            <span
                                                className='text-[#3E9636] cursor-pointer text-[14px] flex justify-center'
                                                onClick={() => {
                                                    setSelectedSubscription(subscription);
                                                    navigate('/BuyFilingSubscription?renewal=true');
                                                }}
                                            >
                                                خرید  و  افزایش اعتبار
                                                <img src='/icons/pelak-arrow-back-simple.svg' alt='arrow icon' />
                                            </span>
                                        </td>
                                    </tr>
                                )
                                : (
                                    <tr>
                                        <td colSpan='5' className='text-center py-10 dark:text-slate-400'>
                                            هیچ اشتراک فعالی موجود نیست
                                        </td>
                                    </tr>
                                )

                        }
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default MySubscription;